import { Box } from '@mui/material';
import { BarPlot } from '@mui/x-charts/BarChart';
import { LinePlot } from '@mui/x-charts/LineChart';
import { ChartContainer } from '@mui/x-charts/ChartContainer';
import { ChartsXAxis } from '@mui/x-charts/ChartsXAxis';
import { ChartsYAxis } from '@mui/x-charts/ChartsYAxis';
import { useTheme } from '@emotion/react';
import { useEffect } from 'react';
import { chartContainerSx, chartSx } from './Chart.style';

export const Chart = ({ name, series, xAxis, yAxis, xLabel }) => {
  const theme = useTheme();

  useEffect(() => {
    const trendsSVG = document.getElementById(`${name}-container`).children[0];
    trendsSVG.setAttribute('viewBox', '0 70 325 325');
  }, [name]);

  return (
    <Box
      id={`${name}-container`}
      component="section"
      sx={chartContainerSx(theme)}
    >
      <ChartContainer
        series={series}
        width={325}
        height={350}
        xAxis={xAxis}
        yAxis={yAxis}
        sx={chartSx}
      >
        <BarPlot />
        <LinePlot />
        <ChartsXAxis
          label={xLabel}
          position="bottom"
          axisId={xAxis[0].id}
          tickFontSize={10}
        />
        <ChartsYAxis
          label={yAxis[0].id}
          position="left"
          axisId={yAxis[0].id}
          tickFontSize={10}
        />
        <ChartsYAxis
          label={yAxis[1].id}
          position="right"
          axisId={yAxis[1].id}
          tickFontSize={10}
        />
      </ChartContainer>
    </Box>
  );
};
